import { useEffect, useState } from 'react';

const matches = (query: string) => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;

/** Whether a CSS media query holds right now, and follows it as the window changes. */
export function useMediaQuery(query: string): boolean {
  const [holds, setHolds] = useState(() => matches(query));
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const onChange = () => setHolds(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);
  return holds;
}

/** Below Tailwind's `sm` (640 px): a phone held upright. */
export const PHONE_QUERY = '(max-width: 639px)';
